import { Injectable } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { UserService } from '@app/user/user.service';
import { config } from '@app/app.config';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadsService {
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private http: HttpClient
  ) {}

  uploads() {
    return this.userService.currentUser({ includeUploads: true, pollInterval: 1000 });
  }

  preUpload(files: File[]) : Observable<string[]> {
    return this.http
      .post<string[]>(
          config.httpURL + `/api/preupload`,
          { files: files.map(f => f.name) },
          { params: { token: this.authService.getAccessToken() }}
      );
  }

  delete(uploadId: string) {
    return this.http
      .delete(
        config.httpURL + `/api/deleteUpload/${uploadId}`,
        { params: { token: this.authService.getAccessToken() }}
      );
  }
}
